import MoonOutlined from '@ant-design/icons/MoonOutlined'
import SunOutlined from '@ant-design/icons/SunOutlined'

import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import { useMe } from '@shared/providers/src/MeProvider'
import { BuildEnv } from '@shared/utils'

import useColorScheme from '@hooks/useColorScheme'

export default function ThemeToggle({ size }) {
  const me = useMe()
  const env = import.meta.env.VITE_BUILD_ENV

  const [mode, setMode] = useColorScheme(me)

  if (env === BuildEnv.Production && !me.superAdmin) return null

  const isDark = mode === 'dark'

  return (
    <Tooltip title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
      <IconButton
        size={size}
        color="secondary"
        onClick={() => setMode(isDark ? 'light' : 'dark')}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? <SunOutlined style={{ fontSize: 19 }} /> : <MoonOutlined style={{ fontSize: 19 }} />}
      </IconButton>
    </Tooltip>
  )
}
